import axios from 'axios';
import { API_URL } from '../const/const';

export const getMarketData = async () => {
  try {
    const response = await axios.get(`${API_URL}/market/api/get_market`, {
      headers: {
        'accept': '*/*'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching market data:', error);
    throw error;
  }
}; 